import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/tokens.css'
import './styles/app.css'

import { App } from './App.js'
import { QueryClientProvider } from '@tanstack/react-query'
import { reportBrandInDev } from './lib/brand-check.js'
import { AuthProvider } from './lib/auth.js'
import { createQueryClient } from './lib/query.js'

const root = document.getElementById('root')
if (root === null) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)

void reportBrandInDev()
